<template>
  <section class="block-contacts contacts">
    <observer @display="waitYmaps"></observer>
    <div class="container">
      <div class="contacts__content">
        <h3 class="contacts__title title">Забронируйте Абонемент</h3>
        <callback-input
          :data="{ type: 'sale', form: 'contacts' }"
          v-on="$listeners"
        >
          Забронировать
        </callback-input>
      </div>
    </div>

    <div class="contacts__address" v-if="showAddress">
      Комсомольский пр., 28
    </div>

    <div class="contacts__map" id="ya-karto"></div>
  </section>
</template>

<script>
import Mask from "../common/mask";
import Mixin from "../common/mixin";
import Keyup from "../common/keyup";
import CallbackInput from "./callback-form/callback-input";
import Observer from "./observer.vue";
import placemarkImg from "../images/utils/map.svg";

export default {
  name: "block-contacts",
  components: { CallbackInput, Observer },
  directives: { Mask, Keyup },
  mixins: [Mixin],
  data() {
    return {
      phone: "",
      showAddress: true,
    };
  },
  methods: {
    initYandexMap() {
      const isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (
            isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
          );
        },
      };

      let zoomControl = new ymaps.control.ZoomControl({
        options: {
          position: {
            left: "auto",
            right: 9,
            top: 108,
          },
        },
      });

      let center_x = this.CONSTANTS.coords.x_center;
      let center_y = this.CONSTANTS.coords.y_center;

      let myMap = new ymaps.Map(
        "ya-karto",
        {
          center: [center_y, center_x],
          zoom: 14,
          controls: [],
        },
        {
          searchControlProvider: "yandex#search",
        }
      );
      if (!isMobile.any()) {
        myMap.controls.add(zoomControl);
      }

      this.CONSTANTS.offices.forEach((point, i) => {
        let myPlacemark = new ymaps.Placemark(
          [point.y, point.x],
          {
            iconContent: point.address,
          },
          {
            iconLayout: "default#image",
            iconImageHref: placemarkImg,
            iconImageSize: [40, 60],
            iconImageOffset: [-20, -50],
            iconContentOffset: [45, 3],
          }
        );

        myPlacemark.events.add("click", () => {
          this.showAddress = !this.showAddress;
        });

        myMap.geoObjects.add(myPlacemark);
      });

      myMap.events.add("click", function (e) {
        // Получение координат щелчка
        console.log(myMap);
        var coords = e.get("coords");
        // alert(coords.join(', '));
      });

      if (isMobile.any() || this.device_platform !== "desktop") {
        myMap.behaviors.disable("drag");
      }
      myMap.behaviors.disable("scrollZoom");
    },
    waitYmaps() {
      let script = document.createElement("script");
      script.src = "//api-maps.yandex.ru/2.1/?load=package.standard&lang=ru_RU";
      document.head.appendChild(script);
      script.onload = () => {
        ymaps.ready(this.initYandexMap);
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.contacts {
  margin-top: 80px;
  position: relative;

  .container {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 50;
    padding-top: 66px;
    pointer-events: none;
  }

  &__content {
    width: 310px;
    max-width: 100%;
    padding: 32px 32px 28px 32px;
    background-color: #fff;
    z-index: 100;
    pointer-events: all;
  }

  &__title {
    font-size: 32px;
    margin-bottom: 32px;
  }

  &__map {
    width: 100%;
    height: 435px;
  }

  &__address {
    padding: 5px;
    font-size: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    background: #fff;
    border: 1px solid #000;
    z-index: 100;
  }
}

@media (max-width: 800px) {
  .contacts {
    .container {
      padding-top: 32px;
    }
    &__content {
      padding: 24px;
    }
    &__title {
      font-size: 24px;
    }
    &__map {
      height: 293px;
    }
  }
}

@media (max-width: 640px) {
  .contacts {
    display: flex;
    flex-direction: column-reverse;
    .container {
      position: static;
      transform: none;
      padding-top: 24px;
    }

    &__content {
      margin: 0 auto;
    }

    &__map {
      height: 350px;
    }
  }
}
</style>
